import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { Exercise } from "../../../models/Exercise";

const WARSAW_TZ = "Europe/Warsaw";

export function formatExerciseClock(timeMs: number): string {
  return format(utcToZonedTime(timeMs, WARSAW_TZ), "HH:mm");
}

export function remainingPlaces(item: Exercise): number {
  return item.capacity - (item.prereservation + item.reserved);
}

export function slotIsAvailable(item: Exercise): boolean {
  return item.capacity > item.reserved + item.prereservation;
}
